export default {
    chatRoom: 'Chat Room',
    theme_light: 'Light Theme',
    theme_dark: 'Dark Theme',
    fullscreen: 'Fullscreen',
    exitFullscreen: 'Exit Fullscreen',
    top: 'TOP'
}
